import React from 'react';
import { hot } from 'react-hot-loader';
import Link from 'redux-first-router-link';
import s from './Button.scss';

const Button = ({ variantClasses = [], text, type, location, href, id = false, disabled = false, clickEventHandler = () => {}, mouseEnterEventHandler, mouseLeaveEventHandler, style = {}, children }) => {
	let classes = [s.button];
	if (variantClasses) classes = [...classes, ...(Array.isArray(variantClasses) ? variantClasses.map((c) => s[c]) : [s[variantClasses.toString()]])];
	const innerElements = text || children;

	if (type === 'link' && !location) return <span className={classes.join(' ')} style={style}>{ innerElements }</span> || null;

	const externalLink = /^(https?|mailto|tel)/.test(location);
	const anchorLink = /^#/.test(location);

	if (type === 'a' || (type === 'link' && externalLink) || (type === 'link' && anchorLink)) {
		const attrs = {};
		if (href) attrs.href = href;
		if (id) attrs.id = id;
		if (!attrs.href && location) attrs.href = location;
		if (externalLink) {
			attrs.rel = 'noreferrer noopener';
			attrs.target = '_blank';
		}
		return <a className={classes.join(' ')} {...attrs} onClick={clickEventHandler} style={style}>{ innerElements }</a>; // eslint-disable-line
	}
	if (type === 'link') {
		return <Link className={classes.join(' ')} to={location} onClick={clickEventHandler} style={style}>{ innerElements }</Link>;
	}
	// eslint-disable-next-line react/button-has-type
	return <button className={classes.join(' ')} disabled={disabled} type={type} onClick={clickEventHandler} onMouseEnter={mouseEnterEventHandler} onMouseLeave={mouseLeaveEventHandler} style={style}>{ innerElements }</button>;
};

export default hot(module)(Button);
